import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const BackButtonStyles = makeStyles((theme: Theme) =>
  createStyles({
    homeButton: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontSize: '18px',
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 600,
      cursor: 'pointer',
    },
  }),
);
